import { CREATE, DELETE, EDIT, VIEW, CHECK, STUDENT, COMPANY, ANCHOR, UNIVERSITY } from 'utils/constant'

export default {
  // 学生角色
  [STUDENT]: {
    'student': [CREATE, DELETE, EDIT, VIEW],
    'home': [CREATE, DELETE, EDIT, VIEW, CHECK],
    'index': [CREATE, DELETE, EDIT, VIEW, CHECK],
    'news': [DELETE],
    'menu-news': [VIEW],
    'menu-profession': [VIEW],
    'menu-company': [VIEW],
    'menu-position': [VIEW],
    'menu-course': [VIEW],
    'menu-bbs': [VIEW],
    'menu-knowledge': [VIEW],
    'menu-majorcourses': [VIEW]
  },
  // 企业角色
  [COMPANY]: {
    'menu-news': [VIEW],
    'menu-profession': [VIEW],
    'menu-bbs': [VIEW],
    'btn-resume': [VIEW, CREATE]
  },
  // 主播角色
  [ANCHOR]: {},
  // 学校角色
  [UNIVERSITY]: {}
}



// WEBPACK FOOTER //
// ./src/common/config/role-resource.js